import kr from "Kr/kr";
import HTMLCLass from "../../kr/utils/HTMLClass";

export default class BSPMedia extends kr.Component {
  init() {
    this.WIDTH_TO_RUN = 1024;
    this.HEIGHT_TO_RUN = 700;

    this.isRun = false;
    this.img = this.$element.querySelector(".js--bspMedia");
    this.htmlCopy = this.img.innerHTML;
    this.sections = this.$element.querySelectorAll(".bsp__section");
    this.activeIndex = 0;
    this.savedSection;
    this.zeroOnce = true;
    if (!this.img) {
      console.warn("No js--bspMedia");
      return;
    }
  
    this.setRun();  
    this.bind();
  }

  bind() {
    window.addEventListener("resize", this.setRun.bind(this));
    let bounce = false;
    window.addEventListener("scroll", () => {
      if (bounce || !this.isRun) {
        return;
      }
      bounce = true;
      if (this._isEndOfDivOnScreen(this.$element, 165)) {
        HTMLCLass.addClass(this.$element, "js--bspMedia--fixed");
        HTMLCLass.addClass(this.$element, "js--bspMedia--fixed-end");
      } else if (this._isElementNearTopOfViewport(this.$element, 180)) {
        HTMLCLass.addClass(this.$element, "js--bspMedia--fixed");
        HTMLCLass.removeClass(this.$element, "js--bspMedia--fixed-end");
        this.processSections();
      } else {
        HTMLCLass.removeClass(this.$element, "js--bspMedia--fixed");
        HTMLCLass.removeClass(this.$element, "js--bspMedia--fixed-end");
        if (!this.zeroOnce) {
            this.img.innerHTML = this.htmlCopy;
            this.zeroOnce = true;
        }
      }

      setTimeout(() => {
        bounce = false;
      }, 10);
    });
  }

  setRun() {
    if (
      window.innerWidth < this.WIDTH_TO_RUN ||
      window.innerHeight < this.HEIGHT_TO_RUN
    ) {
      HTMLCLass.removeClass(this.$element, "bsp--2");
      this.isRun = false;
    } else {
      HTMLCLass.addClass(this.$element, "bsp--2");
      this.isRun = true;
    }
  }

  processSections() {
    let foundSection = null;
    const sections = [...this.sections].reverse();
    for (let i in sections) {
        if (!sections.hasOwnProperty(i) || i == (sections.length - 1)) {
            continue;
        }
        const section = sections[i];
        if (this._isElementVisibleFromBottom(section, 500)) {
            foundSection = section;
            this.activeIndex = i;
            break;
        }
    }
    if (foundSection && this.savedSection != foundSection) {
        let html;
        html = foundSection.querySelector('.bsp__media').innerHTML;
        this.img.innerHTML = html;
        this.savedSection = foundSection;
        this.zeroOnce = false;
    } else if (foundSection == null && !this.zeroOnce) {
        this.img.innerHTML = this.htmlCopy;
        this.savedSection = foundSection;
        this.zeroOnce = true;
    }
  }

  _isElementNearTopOfViewport(element, tolerance = 0) {
    const rect = element.getBoundingClientRect();
    return rect.top <= tolerance;
  }
  _isElementInViewport(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight =
      window.innerHeight || document.documentElement.clientHeight;

    return rect.top < windowHeight && rect.bottom > 0;
  }

  _isElementVisibleFromBottom(element, tolerance = 0) {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  
    return rect.top <= windowHeight - tolerance;
  }

  _isEndOfDivOnScreen(element, tolerance = 0) {
    let rect = element.getBoundingClientRect();
    let windowHeight = window.innerHeight;
    return rect.bottom <= windowHeight - tolerance;
}

}

kr.registerComponent(".js--bspMediaContainer", {
  component: BSPMedia,
});
